import { render, staticRenderFns } from "./BaseBlockEditorHome.vue?vue&type=template&id=5806e3ed&scoped=true&"
import script from "./BaseBlockEditorHome.vue?vue&type=script&lang=js&"
export * from "./BaseBlockEditorHome.vue?vue&type=script&lang=js&"
import style0 from "./BaseBlockEditorHome.vue?vue&type=style&index=0&id=5806e3ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5806e3ed",
  null
  
)

export default component.exports